<script setup lang="ts"></script>

<template>
  <h1
    class="flex items-center gap-4 overflow-hidden text-3xl font-extrabold tracking-tight whitespace-nowrap text-slate-900"
  >
    <slot />
  </h1>
</template>
